<template>
  <div class="exportTaskPage uk-position-relative">
    <v-search
      v-bind="searchAttrs"
      @searchFn="search"
      @addFn="addFn"
      @deleteFn="mulDel"
      @resetFn="resetFn"
    />
    <div class="componentPage">
      <SuperTable
        ref="stable"
        :req="getExportListPage"
        :params="[searchAttrs.SearchForm]"
        :columns="columns"
        :selection="true"
      >
        <template #operation="{ row }">
          <!-- 启动 -->
          <i v-if="row.status === 0" class="el-icon-video-play cursor-pointer mr-5"
            :title="$t('text.Activated')" @click="startTask(row)"></i>
           <!-- 停止 -->
          <i v-else class=" el-icon-video-pause cursor-pointer mr-5"
            :title="$t('integration.stop_it')" @click="stopTask(row)"></i>
          <!-- 详情 -->
          <i
            class="el-icon-tickets cursor-pointer mr-5"
            :title="$t('integration.details')"
            @click="detailFn(row)">
          </i>
          <!-- 历史 -->
          <i class="iconfont icon-lishijilu cursor-pointer mr-5"
            :title="$t('device.history')"
            @click="historyFn(row)"></i>
          <!-- 删除 -->
          <i
            class="el-icon-delete cursor-pointer"
            :title="$t('public.btn_delete')"
            @click="delTask(row)"
          ></i>
        </template>
      </SuperTable>
    </div>

    <AddDialog v-if="isShowAddDialog" :isShow.sync="isShowAddDialog" :type="type" :taskId="taskId"/>

    <Detail v-if="isShowDeatil" :isShow.sync="isShowDeatil" :taskId="taskId" />

    <History v-if="isShowHistory" :isShow.sync="isShowHistory" :taskId="taskId"/>

  </div>
</template>
<script>
import { verificationStatus } from "@/utils/convert.js"
import { columns } from "./columns.js"
import SuperTable from '@/components/SuperTable/SuperTable.vue'
import { getExportListPage, exportTaskDel, exportTaskDelBatch, startExportTask, stopExportTask,
   getExportTaskDetail } from "@/api/modules/export"
import AddDialog from './AddDialog.vue'
import Detail from './detail.vue'
import History from './history.vue'


export default {
  components: { SuperTable, AddDialog, Detail, History  },
  data() {
    return {
      getExportListPage,
      columns,
      // 条件搜索属性整合
      searchAttrs: {
        formContent: [ // 搜索form
          {
              id: 1,
              text: 'route.exportTask',
              type: 'input',
              paramsName: 'taskName',
              isChooze: false
          },
          {
              id: 2,
              text: 'integration.state',
              type: 'select',
              paramsName: 'status',
              selectParam: verificationStatus,
              isChooze: true
          },
        ],
        SearchForm: { // 搜索提交上去的参数
          taskName: null,
          status: null,
          iDisplayStart: 0,
          iDisplayLength: 15
        },
        inline: true,
        optareBtn: [ // 操作按钮
          {
            id: 1,
            icon: '',
            text: 'integration.add',
            method: 'addFn'
          },
          {
            id: 2,
            icon: '',
            text: 'integration.delete',
            method: 'deleteFn'
          },
        ]
      },
      isShowAddDialog: false,
      isShowDeatil: false,
      detailObj: {},
      isShowHistory: false,
      taskId: null,
      type: 'add' // 新增还是编辑

    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      this.$refs.stable.getList()
    },
    search (params) {
      this.getList()
    },
    addFn(){
      this.type = 'add'
      this.isShowAddDialog = true
    },
    async mulDel(){
      const selection = this.$refs.stable.getSelection()
      if (!selection.length) {
        this.$message.warning($t('integration.please_select_at_least_one_data'))
        return
      }

      await this.$confirm(
        this.$t(
          $t('integration.are_you_sure_you_want_to_perform_this_operation_q')
        )
      )
      await exportTaskDelBatch(selection.map(item => item.id))
      this.$message.success($t('integration.success'))
      this.getList()
    },
    resetFn(){
      this.searchAttrs.SearchForm = {
        taskName: null,
        status: null,
        iDisplayStart: 0,
        iDisplayLength: 15
       }
      this.getList()
    },
    delTask(row){
      this.$confirm($t('integration.are_you_sure_you_want_to_delete_this_item')).then(() => {
        exportTaskDel({id: row.id}).then(({ state }) => {
          if (state.code === 200) {
            this.$message.success($t('integration.success'))
            this.getList()
          }
        })
      })
    },
    // 任务详情
    detailFn(row){
      this.isShowDeatil = true
      this.taskId = row.id
    },
    startTask(row){
      startExportTask(row.id).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.getList()
        }
      })
    },
    stopTask(row){
      stopExportTask(row.id).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.getList()
        }
      })
    },
    historyFn(row){
      this.isShowHistory = true
      this.taskId = row.id
    },
    download(row){
      downloadTask(row.path).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
        }
      })
    },
    editTask(row){
      this.type = 'edit'
      this.isShowAddDialog = true
      this.taskId = row.id
    }
  }
}
</script>
<style lang="scss" scoped>
.exportTaskPage {
  height: 100%;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;

  .componentPage {
    flex: 1;
    overflow: hidden;
  }
}
</style>
